module.exports = __webpack_public_path__ + "img/material_2023_banner.e4d7aba2.jpg";